import React from 'react';
import { Stack } from '@mui/material';

import { Container, Graphic1, Graphic2, Logo } from './styles';
import LogoPath from 'images/adpkd-registry-logo.svg';
import TopVector from 'images/top-vector.png';
import LeftVector from 'images/left-vector.png';

const Background = () => (
  <Container>
    <Stack
      height='100%' justifyContent='space-between'>
      <Stack
        direction='row' justifyContent='space-between'>
        <Logo
          src={LogoPath} alt=''
        />
        <Graphic1
          src={TopVector} alt=''
        />
      </Stack>
      <Graphic2
        src={LeftVector} alt=''
      />
    </Stack>
  </Container>
);

export default Background;
